<template>
	<div class="p4">
		<!-- Order -->
		<div class="fs4 mt6 mb6 c1">
			<core-form-input
				componentName="j-base-input-number"
				name="order"
				:label="$t('order')"
				v-model="value.order"
			></core-form-input>
		</div>

		<!-- selection -->
		<div class="flex xs-middle xs-right mb6">
			<j-base-toggle size="xsmall" v-model="isOverride" />
			<div class="fw7 ml2">{{ $t("override") }}</div>
		</div>

		<!-- disclaimer -->
		<div
			class="p2 bgWarning fs3 lh150"
			v-if="
				hasHtmlOverride &&
					!isOverride &&
					contentJson &&
					Object.keys(contentJson).length
			"
		>
			This clause has been overriden so the dynamic content will be ignored.
			Switch to override mode if you want to edit the content
		</div>

		<!-- ContentJson -->
		<p
			v-if="!isOverride && contentJson && Object.keys(contentJson).length"
			class="xs-12 fs4 fw7 lh125 mt4 mb2"
		>
			{{ $t("dynamic_content") }}
		</p>
		<div
			v-show="!isOverride"
			v-for="(item, key) in contentJson"
			:key="key"
			class="xs-middle mb3"
		>
			<!-- Label -->
			<div class="xs-12 fs4 fw4 mb1">{{ key }}</div>
			<!-- value -->
			<div class="xsl-12 pr1">
				<core-form-input
					componentName="j-base-input-text"
					:name="`name-${key}`"
					size="small"
					:value="contentJson[key]"
					@input="handleInput(key, $event)"
				/>
			</div>
		</div>

		<!-- Override area -->
		<p v-if="isOverride" class="xs-12 fs4 fw7 lh125 mt4 mb2">HTML</p>
		<j-spinner v-if="isRendering" />
		<core-rich-text-editor
			v-if="isOverride && !isRendering"
			:content="htmlOverride"
			@input="updateHtml"
		/>
	</div>
</template>

<script>
import JButton from "@/components/JButton"
import JSpinner from "@/components/JSpinner"
import JBaseToggle from "@/components/JBaseToggle"
import JCard from "@/components/JCard"
import JExpendableBox from "@/components/JExpendableBox"
import CoreRichTextEditor from "@/modules/core/components/CoreRichTextEditor"
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import { Liquid } from "liquidjs"

export default {
	name: "ClausesUpdate",
	components: {
		JButton,
		JSpinner,
		JCard,
		JExpendableBox,
		CoreRichTextEditor,
		CoreFormInput,
		JBaseToggle
	},
	props: {
		value: Object
	},
	data() {
		return {
			contentJson: null,
			variablesJson: null,
			isOverride: false,
			htmlOverride: null,
			isRendering: false
		}
	},
	methods: {
		parseHtmlToSchema(htmlString) {
			const liquidjs = new Liquid()

			return liquidjs
				.parse(htmlString)
				?.filter(item => item.hasOwnProperty("value"))
				?.map(item => ({
					key: item?.value?.initial?.replace("data.", ""),
					value: item?.value?.filters
						?.find(obj => obj.name === "default")
						?.args?.[0].replace(/'|"/g, "")
				}))
				?.reduce(
					(obj, item) => ({
						...obj,
						[item.key]: item.value
					}),
					{}
				)
		},

		handleInput(key, $event) {
			if (this.checkIsNum($event)) this.contentJson[key] = parseInt($event)
			else this.contentJson[key] = $event
		},

		checkIsNum(value) {
			return /^\d+$/.test(value)
		},

		updateHtml(input) {
			this.htmlOverride = input
			this.$emit("input", {
				...this.value,
				htmlOverride: input
			})
		}
	},

	created() {
		this.contentJson = this.parseHtmlToSchema(this.value?.template?.html)
		this.hasHtmlOverride = Boolean(this?.value?.htmlOverride)
		this.htmlOverride =
			this.value?.htmlOverride || this.value?.renderedHtmlResult?.value
	},

	watch: {
		isOverride: {
			handler(newVal) {
				this.$emit("input", {
					...this.value,
					isOverride: newVal
				})
			}
		},

		contentJson: {
			handler(val) {
				this.$emit("input", {
					...this.value,
					renderParameters: {
						contentJsonString: JSON.stringify(val),
						name: "data",
						variablesJsonString: null
					}
				})
			},
			deep: true,
			immediate: true
		}
	}
}
</script>

<style></style>
